import * as React from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.47,12,21.7,3.78a1,1,0,1,0-1.48-1.47L12,10.53,3.78,2.31A1,1,0,0,0,2.31,3.78L10.53,12,2.31,20.22A1,1,0,0,0,3,22a1.06,1.06,0,0,0,.74-.3L12,13.47l8.22,8.23a1,1,0,1,0,1.48-1.48Z" }));
export default SvgClose;
